"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _Title = _interopRequireDefault(require("../../Title"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("../../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
function PictureComponent(props) {
  var imageSrc = props.imageSrc;
  var _a = (0, _utils.fomateFileData)(imageSrc),
    url = _a.url,
    _b = _a.alt,
    alt = _b === void 0 ? '' : _b;
  var _c = (0, _react.useState)({}),
    styles = _c[0],
    setStyls = _c[1];
  (0, _react.useEffect)(function () {
    var imgLoad = new Image();
    if (url) {
      imgLoad.src = url;
    }
    imgLoad.onload = function () {
      var collectStyles = {};
      if (imgLoad.width < imgLoad.height) {
        collectStyles = {
          height: '100%',
          width: 'auto'
        };
      } else {
        collectStyles = {
          width: '100%',
          height: 'auto'
        };
      }
      setStyls(collectStyles);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("img", {
    style: __assign({
      width: '10px'
    }, styles),
    src: url,
    alt: alt
  });
}
var Article = function Article(props) {
  var href = props.href,
    source = props.source,
    title = props.title,
    className = props.className,
    titleStyle = props.titleStyle,
    article = props.article,
    hrefText = props.hrefText,
    record = props.record;
  var extendProps = (record || {}).extendProps;
  var refsHeight = (0, _react.useRef)(null);
  var hoverRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if ((refsHeight === null || refsHeight === void 0 ? void 0 : refsHeight.current) && hoverRef.current) {
      if (refsHeight.current.clientHeight === refsHeight.current.scrollHeight) {
        hoverRef.current.style.display = 'none';
      }
    }
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", __assign({
    className: (0, _classnames["default"])('flex-default-article', className)
  }, extendProps || {}, {
    onClick: function onClick() {
      if (!href) return;
      window.location.href = href;
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-default-article-container')
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: 'flex-related-class'
  }, source && ( /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-related-image-class'
  }, /*#__PURE__*/_react["default"].createElement(PictureComponent, {
    imageSrc: source
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      wordBreak: 'break-word'
    }
  }, title && ( /*#__PURE__*/_react["default"].createElement("strong", {
    className: 'wordBreak lineBreak',
    style: titleStyle
  }, title)), /*#__PURE__*/_react["default"].createElement("div", {
    ref: refsHeight,
    className: (0, _classnames["default"])('flex-related-div-content'),
    dangerouslySetInnerHTML: {
      __html: article
    }
  }), href && ( /*#__PURE__*/_react["default"].createElement("a", __assign({
    className: 'flex-default-article_a',
    href: href
  }, extendProps || {}), hrefText || "Learn more ", " >"))))));
};
var Thumbnail = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var icon = props.icon,
    banner = props.banner,
    sharp = props.sharp,
    radius = props.radius,
    source = props.source,
    flexTitle = props.flexTitle,
    style = props.style,
    imageSrc = props.imageSrc,
    configuration = props.configuration,
    className = props.className,
    onClick = props.onClick,
    restProps = __rest(props, ["icon", "banner", "sharp", "radius", "source", "flexTitle", "style", "imageSrc", "configuration", "className", "onClick"]);
  var dataLen = configuration ? configuration.length : 0;
  var autoWidth = [1, 2, 3, 4].includes(dataLen);
  var threeWidth = [5, 6, 9].includes(dataLen);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-related-container',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-related-container-children'
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-related-class-name'
  }, configuration === null || configuration === void 0 ? void 0 : configuration.map(function (item, index) {
    var content = item.content,
      title = item.title,
      href = item.href,
      source = item.source,
      hrefText = item.hrefText,
      contentMaxHeight = item.contentMaxHeight;
    return /*#__PURE__*/_react["default"].createElement("div", __assign({
      key: index,
      className: (0, _classnames["default"])("flex-default-text-article ", {
        'flex-default-text-article--default': autoWidth,
        'flex-default-text-article--three': threeWidth,
        'flex-default-text-article--four': !threeWidth && !autoWidth
      }),
      ref: ref
    }, restProps), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('flex-text-article-container flex-text-article-container-border', {
        'flex-text-article-container-box': href
      }, className),
      key: index
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'flex-text-article-container__article'
    }, /*#__PURE__*/_react["default"].createElement(Article, {
      record: item || {},
      article: content,
      title: title,
      href: href,
      hrefText: hrefText,
      contentMaxHeight: contentMaxHeight,
      source: source || 'https://staticintl.cloudcachetci.com/cms/backend-cms/rQmv565_Frame%20117.png'
    }))));
  }))));
});
Thumbnail.displayName = 'TCIThumbnail';
var _default = exports["default"] = Thumbnail;